import { LineString } from 'geojson';
import { BigQueryTable, Slice } from '../../util/types';
import { adjustUtcMinuteToLocal, minutesAsTime } from '../../util/dates';

interface EquidistantRouteExtras {
  mileMarkers: number[];
  bearings: number[];
}

export type EquidistantRoute = LineString & EquidistantRouteExtras;

export interface TravelTimeRequest {
  route: EquidistantRoute;
  startDateTime: string;
  endDateTime: string;
  roadWidth: number;
  movementTable: BigQueryTable;
  fields?: string[];
}

export interface TravelTimeResponse {
  data: (TravelTimeResponseEntity)[];
}

export interface TravelTimeResponseEntity {
  journeyId?: string;
  startTimestamp?: string;
  travelTime?: number;
  unixStartTime?: number;
}

export const createData = (travelTimes: number[]): number[][] => {
  travelTimes.sort((a, b) => a - b);
  return travelTimes.map((value: number, index: number, arr: number[]) => [value, (index / (arr.length - 1)) * 100]);
};

export const getSliceName = (slice: Slice) => {
  const dayStr = slice.days
    .sort((a, b) => a.value - b.value)
    .map(d => d.shortLabel)
    .join('');

  const [timeStr1, timeStr2] = slice.times.map(t => minutesAsTime(adjustUtcMinuteToLocal(t)));
  let timeOfDayStr = '';
  if (adjustUtcMinuteToLocal(slice.times[0]) < adjustUtcMinuteToLocal(slice.times[1])) {
    // normal
    timeOfDayStr = `${timeStr1} - ${timeStr2}`;
  } else if (timeStr1 === '23:59' && timeStr2 === '00:00') {
    // exclude, only 1 minute selected
    timeOfDayStr = `${timeStr1} - ${timeStr2}`;
  } else if (timeStr1 === '23:59') {
    timeOfDayStr = `00:00 - ${timeStr2}`;
  } else if (timeStr2 === '00:00') {
    timeOfDayStr = `${timeStr1} - 23:59`;
  } else {
    timeOfDayStr = `00:00 - ${timeStr2}, ${timeStr1} - 23:59`;
  }
  return `${dayStr}, ${timeOfDayStr}`;
};
